// upgrade button
//
//   <upgrade-botton >
//

let module = angular.module('app.directives');

module.directive('upgradeButton', () => {
  return {
    restrict: 'E',
    scope: {},
    template: `
      <button type="button" ng-click="vm.onClick($event)" class="btn btn-default" style="margin:15px">
        {{::vm.title()}}
      </button>
    `,
    controllerAs: 'vm',
    controller: function ($rootScope, MeetingsService) {
      'ngInject';
      const { account } = $rootScope;

      this.title = () => {
        return 'Review Upgrade Options';
      };

      this.onClick = ($event) => {
        MeetingsService.openPreferredMethod();
      };
    },
  };
});



// WEBPACK FOOTER //
// ./app/directives/upgrade-button.js